export class ForgeAgent {
    constructor(model) {
        this.id = model.id;
        this.name = model.name;
        this.behavior = model.behavior;
    }
}
